import React, { useState, useEffect } from 'react';
import { InputNumber, Button, message } from 'antd';
import styles from './index.module.scss';

interface CartCounterProps {
  initialValue?: number;
  min?: number;
  max?: number;
  disabled?: boolean;
  onChange?: (value: number) => void;
}

const CartCounter: React.FC<CartCounterProps> = ({
  initialValue = 1,
  min = 1,
  max = 99,
  disabled = false,
  onChange
}) => {
  const [count, setCount] = useState(initialValue);

  // 当 initialValue 改变时，更新内部状态
  useEffect(() => {
    setCount(initialValue);
  }, [initialValue]);

  const handleChange = (value: number | null) => {
    if (value === null) {
      const newValue = min;
      setCount(newValue);
      onChange?.(newValue);
    } else {
      

      const newValue = Math.min(Math.max(value, min), max);
      setCount(newValue);
      onChange?.(newValue);

      // if(value>max){
      //   message.error('The maximum quantity is ' + max);
      // }
    }
  };

  const addCount = () => {
    if (count < max) {
      const newValue = count + 1;
      setCount(newValue);
      onChange?.(newValue);
    }
  };

  const reduceCount = () => {
    if (count > min) {
      const newValue = count - 1;
      setCount(newValue);
      onChange?.(newValue);
    }
  };

  const selectBefore = (
    <Button onClick={reduceCount} disabled={disabled || count <= min}>
      -
    </Button>
  );

  const selectAfter = (
    <Button onClick={addCount} disabled={disabled || count >= max}>
      +
    </Button>
  );

  return (
    <div className={styles['cart-counter']}>
      <InputNumber
        value={count}
        disabled={disabled}
        onChange={handleChange}
        addonBefore={selectBefore}
        addonAfter={selectAfter}
        min={min}
        max={max}
      />
    </div>
  );
};

export default CartCounter; 